module.exports = __webpack_public_path__ + "img/ma246.199490ea.png";